let menuItems = document.getElementsByClassName("menu-item-has-children");
let timer = [];
[].forEach.call(menuItems, function(item, i){
    item.childNodes[0].addEventListener("click", function (e) {
      e.preventDefault();
    })
    item.addEventListener("click", function(e) {
        item.classList.toggle("open-toggle")
    })
  item.addEventListener("mouseover", function() {
    clearTimeout(timer[i]);
    item.classList.add("open")
  })
  item.addEventListener("mouseout", function() {
    timer[i] = setTimeout(function(){
      item.classList.remove("open")
    }, 250)
    
  })
})

let tabbedSections = document.getElementsByClassName("tabbed-info");
let tabbedObj = [].map.call(tabbedSections, function(tabGroup, i){
    let infoSections = tabGroup.getElementsByClassName('info-tab__tab-info')
    tabGroup.style.height = (infoSections[0].clientHeight + 60) + 'px';
    let tabGroupObj = [].map.call(tabGroup.getElementsByClassName('info-tab'), function(oTab, j) {
      oTab.getElementsByClassName('info-tab__header')[0].addEventListener("click", function(clickEvent) {
        clickEvent.preventDefault();
        let height;
        tabbedObj[i].tabs.forEach(function(tab, k) {
          if (tab.element.getElementsByClassName('info-tab__header')[0] === clickEvent.target) {
            tab.element.classList.add("info-tab--selected")
            tab.selected = true;
            
            tabGroup.style.height = (infoSections[k].clientHeight + 60) + 'px';
          } else if (tab.selected) {
            tab.element.classList.toggle("info-tab--selected")
            tab.selected = !tab.selected;
          }
        })
      })
      return {element: oTab, selected: oTab.classList.contains('info-tab--selected')}
    })
    return {element: tabGroup, tabs: tabGroupObj};
  })

function navMenuDepth() {
  if(wp && wp.hooks) wpNavMenu.options.globalMaxDepth = 1;
}

document.addEventListener("DOMContentLoaded", function() {
  navMenuDepth();
});

